import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

export default function ResourceImageValueComponent( props ) {
  // to do: make valuestyle the style of the image
  // make a more tailored model + editor for images
  const { value, path, valueStyle, clientProps } = props
  const { delegate } = clientProps
  const [ image, setImage ] = useState()
  const [ loading, setLoading ] = useState( false )
  const ref = useRef()
  const dispatch = useDispatch()

  // for if the user edits the image
  useEffect( () => {
    if ( image ) {
      getImage( dispatch, delegate, path, setImage, setLoading )
    }
  }, [ value ] )

  const observer = useMemo( () => {
    return new IntersectionObserver( ( [ entry ] ) => {
      if ( entry.isIntersecting && !image && !loading && value && delegate ) {
        getImage( dispatch, delegate, path, setImage, setLoading )
      }
    } )
  }, [ ref ] )

  useEffect( () => {
    if ( ref.current ) {
      observer.observe( ref.current )
    }
    return () => observer.disconnect()
  }, [ ref ] )

  if ( loading ) {
    return (
      <div
        style={{
          height : 635,
          display : 'flex',
          justifyContent : 'center',
          alignItems : 'center',
        }}>
        <i
          className="fa fa-fw fa-spin fa-spinner fa-3x"
          style={{
            color : 'var(--color-brand500)',
          }}/>
      </div>
    )
  }
  // if there is no image, render an icon meaning there is no image
  return <img ref={ref} src={image} alt={value} style={valueStyle} />
}

function getImage( dispatch, delegate, path, imageCB, loadingCB ) {
  loadingCB( true )
  dispatch( delegate.resource( path ).get() )
    .then( ( data ) => {
      const {
        data : { url },
      } = data
      imageCB( url )
      loadingCB( false )
    } )
    .catch( ( err ) => {
      console.error( err )
      imageCB( 'err' )
      loadingCB( false )
    } )
}
